import PropTypes from 'prop-types';

export type OrderProps = {
  domain?: string;
  showGdprByDefault?: boolean;
  submitText?: string;
  requestText?: string;
  loginText?: string;
  modalTitle?: string;
  forgotPasswordLink?: string;
  name?: string;
  showRecaptchaHint?: boolean;
  termsLink?: string;
  termsLabel?: string;
  policyLink?: string;
  policyLabel?: string;
  mobileFlowBreakpoint?: number;
  debugOAuth?: boolean;
  debugOAuthProviderUsed?: string;
  shortMode?: boolean;
  useLoginLink?: string;
  hidePaperType?: boolean;
  enableOAuthInitializationPreview?: boolean;
  registrationLink?: string;
  hideLoginPrompt?: boolean;
  forgotPasswordLabel?: string;
};

export const orderPropTypes = {
  domain: PropTypes.string,
  showGdprByDefault: PropTypes.bool,
  submitText: PropTypes.string,
  requestText: PropTypes.string,
  loginText: PropTypes.string,
  modalTitle: PropTypes.string,
  forgotPasswordLink: PropTypes.string,
  name: PropTypes.string,
  showRecaptchaHint: PropTypes.bool,
  termsLink: PropTypes.string,
  termsLabel: PropTypes.string,
  policyLink: PropTypes.string,
  policyLabel: PropTypes.string,
  mobileFlowBreakpoint: PropTypes.number,
  debugOAuth: PropTypes.bool,
  debugOAuthProviderUsed: PropTypes.string,
  shortMode: PropTypes.bool,
  useLoginLink: PropTypes.string,
  hidePaperType: PropTypes.bool,
  enableOAuthInitializationPreview: PropTypes.bool,
  registrationLink: PropTypes.string,
  hideLoginPrompt: PropTypes.bool,
};
